import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

const TransactionInfoCard = ({ counter, desc, className }) => (
  <div className={classnames(styles.card, className)}>
    <hr className={styles.card_hr} />
    <p className={classnames('cr-h2 cr-gradient', styles.card_title)}>
      {counter}
    </p>

    <p className={classnames('cr-lead')}>{desc}</p>
  </div>
);

export default TransactionInfoCard;
